import RoamingStepperPlugin from './plugins/RoamingStepper';
import DatePickerPlugin from './plugins/DatePicker';
import SelectShop from './flow/SelectShop';
import ChooseType from './flow/ChooseType';
import ChooseDate from './flow/ChooseDate';
import ContactDetails from './flow/ContactDetails';
import Summary from './flow/Summary';
import State from './State';
import config from './config';
import campaigns from './config/campaigns';
import CompanyService from './service/Company';
import ApmTypeService from './service/ApmType';
import ApmService from './service/Apm';
import Success from './Success';
import extractApmTypes from './utils/extractApmTypes';
import extractApmTypeTopics from './utils/extractApmTypeTopics';
import encodeHTMLEntities from './utils/encodeHTMLEntities';
var AppointmanApp = /*@__PURE__*/ (function () {
    function AppointmanApp(element) {
        var _this = this;
        this.initLoad = function () {
            ApmTypeService
                .get()
                .then(function (res) {
                _this.state.setState({
                    APPOINTMAN_TYPES: res
                });
                var entryInformation = _this.extractURLParameters();
                if (config.appointman.sandbox) {
                    entryInformation = {
                        rmsID: '200531314',
                        distance: '1,2'
                    };
                }
                if (entryInformation) {
                    if (entryInformation.apmid) {
                        ApmService
                            .get(entryInformation.apmid)
                            .then(function (res) {
                            // The response was OK
                            entryInformation.rmsid = res.rmsid;
                            // extract appointment types, that are available in store
                            var apmType = _this.extractApmType(res.appointmenttype);
                            // extract topics, that are available in store (matching the available types as well)
                            var apmTopic = _this.extractApmTopic(apmType, res.appointmenttopic);
                            var date = res.date.split('.');
                            date = new Date(parseInt(date[2]), parseInt(date[1]) - 1, parseInt(date[0]));
                            _this.state.setState({
                                apmType: apmType,
                                apmTopic: apmTopic,
                                apmID: res.id,
                                date: date,
                                dateLabel: DatePickerPlugin.createDateLabel(date),
                                email: res.email,
                                phone: res.mobilephone,
                                firstname: res.firstName,
                                lastname: res.lastName,
                                customernumber: res.customernumber,
                                text: res.text,
                                timeslot: res.starttime,
                                CURRENT_FLOW: config.appointman.flow.SUMMARY
                            });
                            _this.loadFlow(entryInformation);
                        })
                            .catch(function (error) {
                            // The response was not OK earlier, so let's try to find what's the problem.
                            switch (error.status) {
                                case 403:// The token is invalid so we will send a new email just to double-check the identity of the customer in case of Code 403.
                                    _this.invalidToken();
                                    break;
                                case 404:// "Du kannst nur zukünftige Termine auswählen. Probier’s bitte nochmal." should appear in case of Code 404.
                                    _this.loadApmNotFound();
                                    break;
                                default:
                                    _this.loadApmNotFound();
                                    break;
                            }
                        });
                        return;
                    }
                }
                if (entryInformation) {
                    if (entryInformation.rmsid) {
                        _this.loadFlow(entryInformation);
                    }
                    else {
                        _this.loadRmsNotFound();
                    }
                }
                else {
                    _this.loadRmsNotFound();
                }
            })
                .catch(function () {
                _this.loadRmsNotFound();
            });
        };
        this.extractApmType = function (apmTypeLabel) {
            var apmTypes = _this.state.getState().APPOINTMAN_TYPES;
            for (var prop in apmTypes) {
                if (apmTypes[prop].label === apmTypeLabel) {
                    return prop;
                }
            }
            return '';
        };
        this.extractApmTopic = function (apmType, apmTopicLabel) {
            var apmTopics = _this.state.getState().APPOINTMAN_TYPES[apmType].topics;
            for (var prop in apmTopics) {
                if (apmTopics[prop] === apmTopicLabel) {
                    return prop;
                }
            }
            return '';
        };
        // INVALID TOKEN
        this.invalidToken = function () {
            jQuery(_this.element)
                .find('.loading-wrapper')
                .addClass('loaded');
            jQuery(_this.element)
                .find('.appointman-flow')
                .hide();
            jQuery(_this.element)
                .find('.appointman-invalidtoken')
                .addClass('shown');
            setTimeout(function () {
                jQuery(_this.element)
                    .find('.appointman-invalidtoken')
                    .addClass('loaded');
            }, 5);
            setTimeout(function () {
                jQuery(_this.element)
                    .find('.loading-wrapper')
                    .hide();
            }, 500);
        };
        this.loadRmsNotFound = function () {
            var campaignParameter = '';
            if (_this.campaign) {
                campaignParameter = "&campaign=" + _this.campaign;
            }
            window.location.href = config.appointman.api.SHOPFINDER_URI + "?appointment=1" + campaignParameter;
            jQuery(_this.element)
                .find('.loading-wrapper')
                .addClass('loaded');
            jQuery(_this.element)
                .find('.appointman-flow')
                .hide();
            jQuery(_this.element)
                .find('.appointman-rmsnotfound')
                .addClass('shown');
            setTimeout(function () {
                jQuery(_this.element)
                    .find('.appointman-rmsnotfound')
                    .addClass('loaded');
            }, 5);
            setTimeout(function () {
                jQuery(_this.element)
                    .find('.loading-wrapper')
                    .hide();
            }, 500);
        };
        this.loadApmNotFound = function () {
            jQuery(_this.element)
                .find('.loading-wrapper')
                .addClass('loaded');
            jQuery(_this.element)
                .find('.appointman-flow')
                .hide();
            jQuery(_this.element)
                .find('.appointman-apmnotfound')
                .addClass('shown');
            setTimeout(function () {
                jQuery(_this.element)
                    .find('.appointman-apmnotfound')
                    .addClass('loaded');
            }, 5);
            setTimeout(function () {
                jQuery(_this.element)
                    .find('.loading-wrapper')
                    .hide();
            }, 500);
        };
        this.transform2Digits = function (decimal) {
            var formattedNumber = ("0" + decimal.toString()).slice(-2);
            return formattedNumber;
        };
        this.loadFlow = function (entryInformation) {
            CompanyService
                .get(entryInformation.rmsid)
                .then(function (res) {
                var startDate = new Date();
                var endDate = new Date();
                endDate.setDate(endDate.getDate() + 30);
                var startDateString = _this.transform2Digits(startDate.getDate()) + "." + _this.transform2Digits(startDate.getMonth() + 1) + "." + startDate.getFullYear();
                var endDateString = _this.transform2Digits(endDate.getDate()) + "." + _this.transform2Digits(endDate.getMonth() + 1) + "." + endDate.getFullYear();
                ApmTypeService
                    .getAvailable(entryInformation.rmsid)
                    .then(function (slots) {
                    var apmTypes = extractApmTypes(slots);
                    var apmTypeTopics = extractApmTypeTopics(slots);
                    _this.state.setState({
                        availableApmTypes: apmTypes,
                        availableApmTypeTopics: apmTypeTopics,
                        shopInfo: res,
                        rmsID: entryInformation.rmsid,
                        distance: entryInformation.distance ? entryInformation.distance : false
                    });
                    _this.createFlow();
                    jQuery(_this.element)
                        .find('.loading-wrapper')
                        .addClass('loaded');
                    jQuery(_this.element)
                        .find('.appointman-flow')
                        .addClass('loaded');
                    setTimeout(function () {
                        jQuery(_this.element)
                            .find('.loading-wrapper')
                            .hide();
                    }, 500);
                })
                    .catch(function () {
                    _this.loadRmsNotFound();
                });
            })
                .catch(function () {
                _this.loadRmsNotFound();
            });
        };
        this.extractURLParameters = function () {
            var apmID = _this.getParameterByName('apmid');
            if (apmID) {
                return {
                    apmid: apmID
                };
            }
            var input = _this.getParameterByName('rmsid');
            if (input) {
                if (input.length > 0) {
                    return {
                        rmsid: input,
                        distance: false
                    };
                }
            }
            var campaign = _this.getParameterByName('campaign');
            if (campaign) {
                if (campaign.length > 0) {
                    _this.campaign = campaign.toLowerCase();
                    if (campaigns[_this.campaign]) {
                        return {
                            rmsid: campaigns[_this.campaign].rmsid
                        };
                    }
                    else {
                        return {
                            rmsid: false,
                            campaign: _this.campaign
                        };
                    }
                }
            }
            // redirect
            return false;
        };
        this.createRoamingStepper = function () {
            _this.roamingStepper = new RoamingStepperPlugin(jQuery(config.appointman.selectors.roamingStepper).get(0));
        };
        this.createFlow = function () {
            _this.selectShop = new SelectShop(_this.roamingStepper, _this.state);
            _this.chooseType = new ChooseType(_this.roamingStepper, _this.state);
            _this.chooseDate = new ChooseDate(_this.roamingStepper, _this.state);
            _this.contactDetails = new ContactDetails(_this.roamingStepper, _this.state);
            _this.summary = new Summary(_this.roamingStepper, _this.state);
            _this.success = new Success(jQuery(_this.element).find('.appointman-success').get(0), _this.state);
            _this.selectShop.init();
            _this.chooseType.init();
            _this.chooseDate.init();
            _this.contactDetails.init();
            _this.summary.init();
            _this.summary.onSubmit(function (res) {
                jQuery(_this.element)
                    .find('.appointman-flow')
                    .removeClass('loaded');
                setTimeout(function () {
                    jQuery(_this.element)
                        .find('.appointman-flow')
                        .hide();
                    _this.success.show(res);
                }, 500);
            });
            _this.summary.onCancel(function () {
                jQuery(_this.element)
                    .find('.appointman-flow')
                    .removeClass('loaded');
                setTimeout(function () {
                    jQuery(_this.element)
                        .find('.appointman-flow')
                        .hide();
                    _this.success.show(false);
                }, 500);
            });
        };
        this.createState = function () {
            _this.state = new State();
        };
        this.element = element;
        this.campaign = false;
        this.createState();
        this.createRoamingStepper();
        this.initLoad();
    }
    AppointmanApp.prototype.getParameterByName = function (name, url) {
        if (url === void 0) {
            url = '';
        }
        if (!url)
            url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
        if (!results)
            return null;
        if (!results[2])
            return '';
        // remove plus character from param and decode
        var ret = decodeURIComponent(results[2].replace(/\+/g, ' '));
        // remove all dangerous characters from param
        return encodeHTMLEntities(ret);
    };
    return AppointmanApp;
}());
export default AppointmanApp;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/appointman/app/ts/App.ts
// module id = null
// module chunks = 